import React from "react";

//interfaces and enums
import { getImageAsset } from "../../../../helpers/Images";
import Icon from "../../icons/Icon";
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";




export interface IProfileImages {
    profileImageUrl?: string;
    className?: string;
    secondProfileImageUrl?: string;
    isSquareImage?: boolean;
    defaultSecondProfileImage?: boolean;
    accessToken?: string
    isStaticAsset?: boolean
    isSecondProfileStatic?: boolean
    imageAssetSize?: number
}

const ProfileImage = ({profileImageUrl, className, secondProfileImageUrl, isSquareImage, defaultSecondProfileImage, accessToken, isStaticAsset, isSecondProfileStatic, imageAssetSize = 30} :IProfileImages) => {   
    return (
        <div className={`tc-profile-image-wrapper ${className ?? ""} ${isSquareImage ? "square-image":""}`} aria-hidden="true">
            {profileImageUrl 
                ?   <img src={getImageAsset(imageAssetSize, profileImageUrl, accessToken, isStaticAsset) } className={`profile-image`} alt=""/>
                :   <Icon className={"default-no-user-icon"} iconName={IconLibrary.USER_NONE} sizeInPx="14" color={"var(--thriveLightSlate)"}/>
            }

            {secondProfileImageUrl && <img src={`${getImageAsset(30, secondProfileImageUrl, accessToken, isSecondProfileStatic)}` } className={`second-profile-image`} alt=""/>}

            {defaultSecondProfileImage && <Icon className={"default-no-user-icon"} iconName={IconLibrary.USER_NONE} sizeInPx="14" color={"var(--thriveLightSlate)"}/>}
        </div>
    );
}

export default ProfileImage